import {useContext} from 'react'
import {SpeakingContext} from './SpeakingContext'

export function useSpeakingMap(): Map<string, boolean> {
  return useContext(SpeakingContext)
}
